import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from '../App';
import { mockExpenses, deleteMockExpense, EXPENSE_TYPES } from '../utils/mockData';

function formatMoney(n) { return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }

export default function ExpenseList() {
  const { demoMode, showToast, navigate } = useContext(AppContext);
  const [expenses, setExpenses] = useState([]);
  const [filterType, setFilterType] = useState('all');
  const [filterJob, setFilterJob] = useState('all');
  const [search, setSearch] = useState('');
  const [confirmDelete, setConfirmDelete] = useState(null);

  useEffect(() => { setExpenses(demoMode ? [...mockExpenses] : []); }, [demoMode]);

  const jobs = [...new Set(expenses.map(e => e.jobName))].sort();
  const filtered = expenses.filter(e => {
    if (filterType !== 'all' && e.type !== filterType) return false;
    if (filterJob !== 'all' && e.jobName !== filterJob) return false;
    if (search) { const q = search.toLowerCase(); return (e.description?.toLowerCase().includes(q) || e.jobName?.toLowerCase().includes(q) || e.vendor?.toLowerCase().includes(q)); }
    return true;
  }).sort((a, b) => new Date(b.date) - new Date(a.date));

  const total = filtered.reduce((s, e) => s + Number(e.amount), 0);
  const handleDelete = (expenseId) => { if (demoMode) { deleteMockExpense(expenseId); setExpenses([...mockExpenses]); showToast('Expense deleted'); } setConfirmDelete(null); };
  const typeForId = (id) => EXPENSE_TYPES.find(t => t.id === id) || EXPENSE_TYPES[4];

  return (
    <div className="fade-in">
      <div className="screen-header" style={{ paddingBottom: 12 }}>
        <div><div className="screen-title">EXPENSES</div><div className="screen-subtitle">{filtered.length} records · {formatMoney(total)}</div></div>
        <button onClick={() => navigate('add')} style={{ background: 'var(--accent-orange)', color: 'white', border: 'none', borderRadius: 8, padding: '8px 14px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'var(--font-body)' }}>+ Add</button>
      </div>

      <div style={{ padding: '0 16px 10px' }}>
        <input className="form-input" type="search" placeholder="🔍  Search expenses..." value={search} onChange={e => setSearch(e.target.value)} style={{ fontSize: 14 }} />
      </div>

      <div style={{ display: 'flex', gap: 6, padding: '0 16px 10px', overflowX: 'auto', paddingBottom: 4 }}>
        <button onClick={() => setFilterType('all')} style={{ padding: '6px 12px', borderRadius: 20, border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 600, fontFamily: 'var(--font-body)', flexShrink: 0, background: filterType === 'all' ? 'var(--accent-orange)' : 'var(--bg-raised)', color: filterType === 'all' ? 'white' : 'var(--text-secondary)' }}>All</button>
        {EXPENSE_TYPES.map(t => (
          <button key={t.id} onClick={() => setFilterType(filterType === t.id ? 'all' : t.id)} style={{ padding: '6px 12px', borderRadius: 20, border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 600, fontFamily: 'var(--font-body)', flexShrink: 0, background: filterType === t.id ? t.color : 'var(--bg-raised)', color: filterType === t.id ? 'white' : 'var(--text-secondary)' }}>{t.icon} {t.label}</button>
        ))}
      </div>

      {jobs.length > 1 && (
        <div style={{ padding: '0 16px 12px' }}>
          <select className="form-input" value={filterJob} onChange={e => setFilterJob(e.target.value)} style={{ fontSize: 13 }}>
            <option value="all">All Jobs</option>
            {jobs.map(j => <option key={j} value={j}>{j}</option>)}
          </select>
        </div>
      )}

      {filtered.length === 0 ? (
        <div className="empty-state"><div className="empty-state__icon">🔍</div><div className="empty-state__title">No expenses found</div><div className="empty-state__text">Try changing your filters or add a new expense</div></div>
      ) : (
        <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
          {filtered.map((e, i) => {
            const t = typeForId(e.type);
            return (
              <div key={e.expenseId} className="expense-item-wrap">
                <div className="expense-item" onDoubleClick={() => setConfirmDelete(e.expenseId)} style={{ borderBottom: i < filtered.length - 1 ? '1px solid var(--border)' : 'none' }}>
                  <div className="expense-icon" style={{ background: `${t.color}20` }}>{e.receiptUrl ? '🧾' : t.icon}</div>
                  <div className="expense-info">
                    <div className="expense-info__title">{e.description}</div>
                    <div className="expense-info__sub">{e.jobName}{e.vendor ? ` · ${e.vendor}` : ''} · {e.date}</div>
                    {(e.miles || e.hours) && (<div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2 }}>{e.miles ? `${e.miles} mi @ $${e.ratePerMile}/mi` : ''}{e.hours ? `${e.hours} hrs @ $${e.hourlyRate}/hr` : ''}</div>)}
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4 }}>
                    <div className="expense-amount" style={{ color: t.color }}>{formatMoney(e.amount)}</div>
                    <div className="badge" style={{ background: `${t.color}18`, color: t.color, fontSize: 10 }}>{t.label}</div>
                  </div>
                </div>
                {confirmDelete === e.expenseId && (
                  <div style={{ background: 'var(--bg-raised)', borderTop: '1px solid var(--border)', padding: '12px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>Delete this expense?</span>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button onClick={() => setConfirmDelete(null)} style={{ padding: '6px 14px', borderRadius: 6, border: '1px solid var(--border)', background: 'none', color: 'var(--text-secondary)', cursor: 'pointer', fontSize: 12, fontFamily: 'var(--font-body)' }}>Cancel</button>
                      <button onClick={() => handleDelete(e.expenseId)} style={{ padding: '6px 14px', borderRadius: 6, border: 'none', background: 'var(--accent-red)', color: 'white', cursor: 'pointer', fontSize: 12, fontWeight: 600, fontFamily: 'var(--font-body)' }}>Delete</button>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
      <div style={{ padding: '8px 16px', fontSize: 11, color: 'var(--text-muted)', textAlign: 'center' }}>Double-tap an expense to delete it</div>
      <div style={{ height: 20 }} />
    </div>
  );
}
